/// <amd-module name="TFS/Admin/Groups/Pivots/MemberOf/Redux/MemberOfPivotSelectors" />
import { IMemberOfPivotAwareState, PermissionsGraphGroup, ISearchResultCache } from "TFS/Admin/Groups/Common/Contracts";
import { GraphMembership } from "VSS/Platform/Contracts/Graph";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { GroupPermissions } from "TFS/Admin/Common/Contracts/OrganizationSettings";
import { IIdentity } from "VSSUI/IdentityPicker";
import { IOperationStatus } from "TFS/Admin/Common/Constants/Constants";
import { ObservableArray } from "VSS/Core/Observable";
import { SearchStatus, MemberOfOperation } from "TFS/Admin/Groups/Common/Constants";

export function getMembers(state: IMemberOfPivotAwareState): GraphMembership[] {
    if (!state || !state.memberOfState || !state.memberOfState.identities) {
        return [];
    }

    return state.memberOfState.identities;
}

export function getGroup(state: IMemberOfPivotAwareState): ObservableArray<PermissionsGraphGroup> {
    if (!state || !state.memberOfState || !state.memberOfState.groups) {
        return new ObservableArray([]);
    }

    return state.memberOfState.groups;
}

export function getSearchResult(state: IMemberOfPivotAwareState): ISearchResultCache {
    if (!state || !state.memberOfState) {
        return {
            keyword: "",
            resultItems: [],
            status: SearchStatus.None,
            hasMore: false
        };
    }
    return state.memberOfState.searchResult;
}

export function getShowDeleteMemberOfDialog(state: IMemberOfPivotAwareState): boolean {
    if (!state || !state.memberOfState || !state.memberOfState.groups) {
        return false;
    }

    return state.memberOfState.showDeleteDialog;
}

export function getSelectedItem(state: IMemberOfPivotAwareState): PermissionsGraphGroup | undefined {
    if (!state || !state.memberOfState || !state.memberOfState.groups) {
        return undefined;
    }

    return state.memberOfState.selectedItem;
}

export function getShowMessageCard(state: IMemberOfPivotAwareState): boolean {
    if (!state || !state.memberOfState || !state.memberOfState.groups) {
        return false;
    }

    return state.memberOfState.showMessageCard;
}

export function getMemberOfGroupPermissions(state: IMemberOfPivotAwareState): { [descriptor: string]: GroupPermissions } {
    if (!state || !state.memberOfState) {
        return {};
    }

    return state.memberOfState.selectGroupsPermissions;
}

export function getMessageCardText(state: IMemberOfPivotAwareState): string {
    if (!state || !state.memberOfState || !state.memberOfState.groups) {
        return "";
    }

    return state.memberOfState.messageCardText;
}

export function getMessageCardSeverity(state: IMemberOfPivotAwareState): MessageCardSeverity {
    if (!state || !state.memberOfState || !state.memberOfState.groups) {
        return MessageCardSeverity.Info;
    }

    return state.memberOfState.messageCardSeverity;
}

export function getShowAddMemberOfPanel(state: IMemberOfPivotAwareState): boolean {
    if (!state || !state.memberOfState) {
        return false;
    }
    return state.memberOfState.showAddMemberOfPanel;
}

export function getLoading(state: IMemberOfPivotAwareState): boolean | undefined {
    if (!state || !state.memberOfState) {
        return false;
    }
    return state.memberOfState.loading;
}

export function getInvalidMembers(state: IMemberOfPivotAwareState): IIdentity[] {
    if (!state || !state.memberOfState || !state.memberOfState.invalidMembers) {
        return [];
    }

    return state.memberOfState.invalidMembers;
}

export function getValidMembers(state: IMemberOfPivotAwareState): IIdentity[] {
    if (!state || !state.memberOfState || !state.memberOfState.validMembers) {
        return [];
    }

    return state.memberOfState.validMembers;
}

export function getMultiOperationStatuses(state: IMemberOfPivotAwareState): IOperationStatus[] {
    if (!state || !state.memberOfState || !state.memberOfState.multiOperationStatuses) {
        return [];
    }
    return state.memberOfState.multiOperationStatuses;
}

export function getLastOperation(state: IMemberOfPivotAwareState): MemberOfOperation {
    if (!state || !state.memberOfState || !state.memberOfState.lastOperation) {
        return MemberOfOperation.Fetch;
    }
    return state.memberOfState.lastOperation;
}
